import { Entity } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/query-params';

import { GeographicExposureDrawer } from './drawers/GeographicExposureDrawer';
import * as S from './GeographicExposureTab.styles';
import { CountryExposureTab } from './tabs/CountryExposureTab';
import { RegionalExposureTab } from './tabs/RegionalExposureTab';

const GeoTabs = {
  Country: 'country',
  Regional: 'regional',
};

export interface GeographicExposureTabProps {
  entity: Entity;
}

export const GeographicExposureTab = ({
  entity,
}: GeographicExposureTabProps) => {
  const { t } = useTranslation(['widget']);
  const { params, setQueryParams } = useQueryParams();
  const requestedTab = params[queryKeys.geoSubTab];
  const activeTab =
    requestedTab === GeoTabs.Regional ? GeoTabs.Regional : GeoTabs.Country;

  const TAB_LABELS = [
    t('widget:assetOverview.knowledgeGraph.geographicExposure.countryExposure'),
    t('widget:assetOverview.knowledgeGraph.geographicExposure.regionExposure'),
  ];

  return (
    <S.Root data-testid="geographic-exposure-tab">
      <S.StyledTabPanel
        tabs={[
          {
            tabKey: GeoTabs.Country,
            tabLabel: TAB_LABELS[0],
            renderPanel: <CountryExposureTab entityTag={entity.tag} />,
          },
          {
            tabKey: GeoTabs.Regional,
            tabLabel: TAB_LABELS[1],
            renderPanel: <RegionalExposureTab entityTag={entity.tag} />,
          },
        ]}
        activeTab={activeTab}
        onChange={(_, tabKey) =>
          setQueryParams({ [queryKeys.geoSubTab]: tabKey })
        }
      />

      <GeographicExposureDrawer entity={entity} />
    </S.Root>
  );
};
